import { formatDate } from '@btime/helpers'
import { COLORS } from '@btime/constants'
import React from 'react'

import FlexGrid from '../structure/FlexGrid'
import IconText from './IconText'

const DateTimeIcons = ({ gutter, date, hideTime }) => {
  const formattedDate = formatDate('DD/MM/YYYY', date)
  const formattedTime = formatDate('HH:mm', date)

  return (
    <FlexGrid justify="flex-start" gutter={gutter || 2}>
      <IconText iconName="BsCalendar" label={formattedDate} left iconSize="1rem" color={COLORS.dark3} />
      {!hideTime && <IconText iconName="BsClock" label={formattedTime} left iconSize="1rem" color={COLORS.dark3} />}
    </FlexGrid>
  )
}

export default DateTimeIcons
